import React, { useEffect, useLayoutEffect, useRef, useState } from "react"


export const HeaderContext = React.createContext()
export const HeaderVisibilityProvider = ({ containerRef, children }) => {
    const [visible, setVisible] = useState(true)
    const prevScroll = useRef(0)
    useEffect(() => {
        const container = containerRef?.current
        if (!container) {
            return
        }
        const handleScroll = (e) => {
            const currentScrollTop = e.target.scrollTop
            const delta = currentScrollTop - prevScroll.current
            prevScroll.current = currentScrollTop
            const header = e.target.children[0]
            const rect = header.getBoundingClientRect()
            if (delta < 0) {
                !visible && setVisible(true)
                e.target.classList.remove('no-header')

            } else if (delta >= 0 && currentScrollTop > rect.height) {
                visible && setVisible(false)
                e.target.classList.add('no-header')
                visible && setVisible(false)
            }
        }
        container.addEventListener('scroll', handleScroll)
        return () => container.removeEventListener('scroll', handleScroll)
    }, [visible])

    return <HeaderContext.Provider value={{ visible }}>
        {children}
    </HeaderContext.Provider>
}